import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { TypeAnimation } from 'react-type-animation';
import './Intro.css';
import sherwen from '../../Assets/toga.png';
import handshake from '../../Assets/hand-shake.png';
import address from '../../Assets/location.png';
import phone from '../../Assets/phone.png';
import emailIcon from '../../Assets/envelope.png';



const Intro = () => {

  useEffect(() => {
    AOS.init();
  }, [])




  return (
    <section id='intro'>

    <div class="background-image"></div>
    <div className="introBackground">
    <div className="introAllContent">
    <div className='introContent'>
      <div className="textContent"  >
      <span className='hi'
            data-aos="fade-right"
            data-aos-offset="-300"
            data-aos-delay="0"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out-quart"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-center"
            >Hi!</span>
      <span className='introText'  
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">I'm{' '} 
      <span className="introName">Sherwen Palima</span>
      </span>
      <span className="typeAnimation"  
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="400"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
      <TypeAnimation
        sequence={[
          3000,
          "A Web Developer",
          2000,
          "A Technical Support",
          2000,
          "A Virtual Assistant",
        ]}
        speed={60}
        repeat={Infinity}
      />
      </span>
      <p className='introPara'
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="600"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">"I'm motivated by a profound passion for technology and a strong willingness to learn."
      </p>
      <div className="infoContainer"  
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="800"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
        <div className="contactInf">
            <img src={address} alt="address" className="infoAbout" />
            <small>Anislagan, Maco, Davao de Oro (Philippines)</small>
        </div>
        <div className="contactInf">
            <img src={phone} alt="phone" className="infoAbout" />
            <small>(+63) 948 7987 542</small>
        </div>
        <div className="contactInf">
            <img src={emailIcon} alt="email" className="infoAbout" />
            <small>sherwenpalima1356@gmail.com</small>
        </div>
      </div>

      <p className="reactJS"
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="1000"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">I created this web portfolio using <code>ReactJS</code>.
           </p>


      <a href="PALIMA-Resume.pdf" 
          download="PALIMA-Resume.pdf"
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="1200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
        <button className='btn'>
          <img src={handshake} alt='Hire Me' className='handshake' />Download Resume
        </button>
    </a>
      </div>
    </div>
    <div className="hexagon-container"  
           data-aos="fade-left"
           data-aos-offset="-300"
           data-aos-delay="1600"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
      <div className="imageContainer">
      <img src={sherwen} alt='' className='bg'/>
      </div>
    </div>
    </div>
    </div>
  </section>
  )
}



export default Intro
